<template>
  <div class="section-progress-report">
    <a-spin :spinning="loading">
      <div class="air__utils__heading mb-3">
        <h5 v-if="header.lesson_plan_name">{{ header.lesson_plan_name }}</h5>
        <div class="text-muted" v-if="header.section_name">
          {{ header.section_name }}
        </div>
      </div>

      <a-card :bordered="false">
        <SectionProgressTable
          :data="progressData"
          :loading="loading"
          @viewLogs="openViewLogsModal"
        />
      </a-card>
    </a-spin>

    <view-logs-modal
      :visible="viewLogsVisible"
      :item="selectedItem"
      :readonly="true"
      @close="viewLogsVisible = false"
    />
  </div>
</template>

<script>
import SectionProgressTable from '@/components/lessonplan/report/sectionProgressReport/Table'
import ViewLogsModal from '@/components/teacherprogress/Form/viewTeacherLog'

export default {
  name: 'SectionProgressReport',
  props: {
    plan_id: [String, Number],
    section_id: [String, Number],
  },
  components: { SectionProgressTable, ViewLogsModal },
  data() {
    return {
      loading: true,
      header: {},
      progressData: [],
      viewLogsVisible: false,
      selectedItem: null,
    }
  },
  computed: {
    planId() {
      return this.$route.params.plan_id
    },
    sectionId() {
      return this.$route.params.section_id
    },
  },
  mounted() {
    this.fetchSectionProgressData()
  },
  methods: {
    async fetchSectionProgressData() {
      this.loading = true
      try {
        const { data } = await this.$http.get(
          `/api/lesson-plan/reports/lesson-plan/${this.planId}/section/${this.sectionId}`
        )
        const report = data.data
        this.header = {
          lesson_plan_name: report.lesson_plan.name || 'N/A',
          section_name: report.section || 'N/A',
        }
        this.progressData = report.report || []
      } catch (error) {
        console.error('Error fetching section progress:', error)
        this.$neoNotify.error('Failed to load Section Progress Report.')
      } finally {
        this.loading = false
      }
    },
    openViewLogsModal(record, type) {
      this.selectedItem = { ...record, type, section_id: this.sectionId }
      this.viewLogsVisible = true
    },
  },
}
</script>

<style scoped>
.text-muted {
  font-size: 0.9em;
  color: #8c8c8c;
}
</style>
